import { ReactNode } from "react";
import { ILink, Link } from "./Link";

export function CategoryCardList({
  title,
  link,
  items,
  className,
}: {
  title?: string;
  link?: ILink;
  items: ReactNode[];
  className?: string;
}) {
  return (
    <div className={className}>
      {title && <h3 className='f-ui-03'>{title}</h3>}
      <ul className='flex flex-wrap gap-x-72 gap-y-32 lg:gap-x-92'>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      {link && <Link {...link} buttonVariants={{ variant: "secondary" }} />}
    </div>
  );
}
